import {
  Address,
  parseAddress,
} from "@certn/cascadia/patterns/address-form/types";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useProfile } from "../../../auth/ProfileProvider";
import { SettingsEditItem } from "../../../components/settings-edit/SettingsEditItem";
import { BillingAddressFormCore } from "../../../components/billing/BillingAddressFormCore";
import { Schemas } from "../../../types";

function formatAddress(
  address?: Schemas["PersonalInformationBillingAddress"],
  defaultValue = "-"
) {
  if (!address) {
    return defaultValue;
  }

  return [address.street_address, address.locality].filter(Boolean).join(", ");
}

export function BillingAddressSettings() {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const toggle = () => setExpanded((curr) => !curr);
  const { profile } = useProfile();

  const billingAddress = profile?.billing_address;
  const personalAddress = profile?.profileaddress_set[0];

  // Convert personalAddress (PersonalInformationProfileaddressSet) to Address format
  // parseAddress validates against the schema and ignores extra fields like id
  const convertedPersonalAddress: Address | undefined = personalAddress
    ? parseAddress(personalAddress)
    : undefined;

  let textString = "";
  if (billingAddress) {
    textString = formatAddress(billingAddress);
  } else if (personalAddress) {
    textString = t("Same as Home address");
  } else {
    textString = t("Not provided");
  }

  return (
    <SettingsEditItem
      setting={t("Billing address")}
      value={textString}
      description={t("Use your billing address for payments")}
      expanded={expanded}
      toggle={toggle}
      testID={
        expanded ? "billing-address-cancel-link" : "billing-address-edit-link"
      }
    >
      <BillingAddressFormCore
        defaultAddress={convertedPersonalAddress}
        checkboxLabel={t("Use personal address")}
        initialBillingAddress={billingAddress ?? undefined}
        onSave={toggle}
        testID="billing-address-settings"
      />
    </SettingsEditItem>
  );
}
